import React from "react";
import Icon from "@material-ui/core/Icon";
import {makeStyles} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
    closePanelButton: {
        height: 50,
        width: 10,
        position: "absolute",
        top: '50%',
        left: '100%',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #d8d8d8',
        borderStyle: 'solid solid solid none',
        borderTopRightRadius: 3,
        borderBottomRightRadius: 3,
        cursor: 'pointer',
        '& $span': {
            color: '#ababab'
        },
        '&:hover': {
            background: theme.palette.primary.main,
            '& $span': {
                color: 'white'
            }
        }
    },
}));
const CloseDrawerButton = ({open, toggleDrawer}) => {
    const classes = useStyles();
    return (
        <div className={classes.closePanelButton} onClick={toggleDrawer}>
            <Icon fontSize={"small"} style={{marginLeft: -6}}>
                {open ? 'keyboard_arrow_left' : 'keyboard_arrow_right'}
            </Icon>
        </div>
    )
};

export default CloseDrawerButton